export default "__VITE_ASSET__BDE9HaDk__"